import { Environment } from './environment.model';
export const environment: Environment = {
  host: 'https://api.faisacisal-pistoia.com/api',
  //host: 'http://localhost:3000/api',
  port: 3000,
  name: 'Faisa-Cisal',
  displayName: 'FAISA - CISAL',
  enableProdMode: true,
};
